import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import MyAccountLayout from "@/components/MyAccountLayout"
import StateSuccess from '@/svgs/state-success.svg'
import StateBlank from '@/svgs/state-Blank.svg'
import StateAdd from '@/svgs/state-Add.svg'
import { useState, useEffect } from "react"
import Link from 'next/link'
import { Button } from 'antd'
import styles from "@/styles/my-account/status.module.scss"
import myAccountApi from '@/service/modules/myAccountApi'

export default function MyaccountStatus() {
  interface statusDataInterface {
    contactUsEmail: string,
    orderAmount: number,
    phoneServerNumber: string,
    userStatus: {
      id: number,
      localPickUp: number,
      orderAmount: number,
      phoneService: number,
      pickUpFee: number,
      pointLevel: number,
      title: string
    }
  }

  // 获取用户status数据
  const [statusData, setStatusData] = useState<statusDataInterface | null>(null)
  const getCustomersStatus = async() => {
    try {
      let res = await myAccountApi.customersStatus()
      if (res.data) {
        setStatusData(res.data)
      }
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    getCustomersStatus()
  }, [])

  // statusIcon组件，有值展示Success图标，否则展示Blank图标
  const statusIcon = (type: number) => (
    <>
      { 
        (type !== undefined && type !== 0) 
          ? <StateSuccess className={styles['status-icon']} />
          : <StateBlank className={styles['status-icon']} />
      }
    </>
  )

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta 
          name="description" 
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout>
        <MyAccountLayout>
          <div className={styles['my-account-status']}>

            <div className={styles['title']}>My Status</div>

            <div className={styles['status-table']}>
              <div className={styles['status-table-header']}>
                <div className={styles['header-item']}>Valued Customer</div>
                <div className={styles['header-item']}>Order Total</div>
                <div className={styles['header-item']}>CrazyPoints</div>
                <div className={styles['header-item']}>Phone Service</div>
                <div className={styles['header-item']}>Local Pick Up</div>
                <div className={styles['header-item']}>
                  <div className={styles['item-title']}>
                    Pickup Charge
                  </div>
                  <div className={styles['item-subtitle']}>
                    { `Order < $100` }
                  </div>
                </div>
              </div>

              <div className={styles['status-table-content']}>
                <div className={styles['content-item']}>{statusData?.userStatus.title}</div>
                <div className={styles['content-item']}>${ parseFloat(`${statusData?.orderAmount}`).toFixed(2)}</div>
                <div className={styles['content-item']}>{statusData?.userStatus.pointLevel || 1}x</div>
                <div className={styles['content-item']}>
                  {statusIcon(statusData?.userStatus.localPickUp || 0)}
                </div>
                <div className={styles['content-item']}>
                  {statusIcon(statusData?.userStatus.localPickUp || 0)}
                </div>
                <div className={styles['content-item']}>
                  { 
                    (statusData?.userStatus.localPickUp !== undefined && statusData?.userStatus.localPickUp !== 0) 
                      ? <><StateAdd className={styles['status-icon']} />{statusData?.userStatus.pickUpFee}</>
                      : <StateBlank className={styles['status-icon']} />
                  }
                </div>
              </div>
            </div>

            <div className={styles['support-table']}>
              <div className={styles['support-table-header']}>
                <div className={styles['header-item']}>Support Status</div>
              </div>

              {
                !!(statusData?.userStatus.phoneService) &&
                <>
                  <div className={styles['support-table-content']}>
                    <div className={styles['content-item']}>General Enquiry</div>
                    <div className={styles['content-item']}>{statusIcon(1)}</div>
                    <div className={styles['content-item']}>{statusData?.phoneServerNumber}</div>
                  </div>

                  <div className={styles['support-table-content']}>
                    <div className={styles['content-item']}>Payment Enquiry</div>
                    <div className={styles['content-item']}>{statusIcon(1)}</div>
                    <div className={styles['content-item']}>{statusData?.phoneServerNumber}</div>
                  </div>

                  <div className={styles['support-table-content']}>
                    <div className={styles['content-item']}>Delivery Enquiry</div>
                    <div className={styles['content-item']}>{statusIcon(1)}</div>
                    <div className={styles['content-item']}>{statusData?.phoneServerNumber}</div>
                  </div>

                  <div className={styles['support-table-content']}>
                    <div className={styles['content-item']}>Address Problem</div>
                    <div className={styles['content-item']}>{statusIcon(1)}</div>
                    <div className={styles['content-item']}>{statusData?.phoneServerNumber}</div>
                  </div>
                </>
              }

              <div className={styles['support-table-content']}>
                <div className={styles['content-item']}>Place Phone Order</div>
                <div className={styles['content-item']}>{statusIcon(0)}</div>
                <div className={styles['content-item']}>
                  <Link
                    href={'/'}
                    passHref
                    legacyBehavior
                  >
                    <a className={styles['link']} rel="noopener noreferrer">www.crazysales.com.au</a>
                  </Link>
                </div>
              </div>
              <div className={styles['support-table-content']}>
                <div className={styles['content-item']}>Technical Support</div>
                <div className={styles['content-item']}>{statusIcon(0)}</div>
                <div className={styles['content-item']}>
                  <Link
                    href={'/contact-us'}
                    passHref
                    legacyBehavior
                  >
                    <a className={styles['link']} rel="noopener noreferrer">Send Feedback</a>
                  </Link>
                </div>
              </div>

              <div className={styles['support-table-content']}>
                <div className={styles['content-item']}>Warranty</div>
                <div className={styles['content-item']}>{statusIcon(0)}</div>
                <div className={styles['content-item']}>
                  <Link
                    href={'/contact-us'}
                    passHref
                    legacyBehavior
                  >
                    <a className={styles['link']} rel="noopener noreferrer">Send Feedback</a>
                  </Link>
                </div>
              </div>

              <div className={styles['support-table-content']}>
                <div className={styles['content-item']}>Order Discount</div>
                <div className={styles['content-item']}>{statusIcon(0)}</div>
                <div className={styles['content-item']}>
                  <Link
                    href={'/contact-us'}
                    passHref
                    legacyBehavior
                  >
                    <a className={styles['link']} rel="noopener noreferrer">Send Feedback</a>
                  </Link>
                </div>
              </div>
            </div>

            <div className={styles['note']}>
              <span className={styles['note-title']}>Note: </span>Order total only counts successful orders for the past 12 months. (Order Status: Sent)
            </div>

            <div className={styles['bulk-order']}>
              <div className={styles['bulk-order-title']}>For Bulk Orders</div>
              <div className={styles['bulk-order-content']}>
                For orders with more than 20 pcs or for any single order amount totalling more than $2000 (QTY&gt;=5), we can provide you with a special quotation to give you the best value for your purchase. Please 
                <Link
                  href={'/contact-us'}
                  passHref
                  legacyBehavior
                >
                  <a className={styles['link']} rel="noopener noreferrer">Contact Us</a>
                </Link>
                for more details.
              </div>
            </div>

            <div className={styles['bulk-order']}>
              <div className={styles['bulk-order-title']}>For Melbourne Local Pick Up</div>
              <div className={styles['bulk-order-content']}>
                We offer a pick up option only for customers who are of Silver level or higher.
              </div>

              <div className={styles['bulk-order-subcontent']}>
                If the order is less than $100, we will charge a $10 handling fee.
              </div>
              <div className={styles['bulk-order-subcontent']}>
                No pick-up option is available if the order contains items from the following categories : Computers & IT / Memory Cards & USB
              </div>
              <div className={styles['bulk-order-subcontent']}>
                Please email us at
                <Link
                  href={`mailto:${statusData?.contactUsEmail}`}
                  passHref
                  legacyBehavior
                >
                  <a className={styles['link']} rel="noopener noreferrer">{statusData?.contactUsEmail}</a>
                </Link>
                for our pick-up address and pick-up time confirmation.
              </div>
            </div>

            <div className={styles['continue-shopping']}>
              <Link
                href={'/'}
                passHref
                legacyBehavior
              >
                <a rel="noopener noreferrer">
                <Button className={styles['continue-shopping-btn']}>Continue Shopping</Button>
                </a>
              </Link>
            </div>

          </div>
        </MyAccountLayout>
      </DefaultLayout>
    </>
  )
}